import {styled} from "@mui/material/styles"
import {breakpoints} from "@next/themes"
import Typography from "@mui/material/Typography"
import Link from "@mui/material/Link"

interface PriceLinkProps {
    saleprice: string | null
}

interface PriceTextProps {
    $brandNameEnabled: boolean
    $brandedMarkdownSalePrice?: boolean
}

interface SalePriceProps extends PriceTextProps {
    component: string
}

export const PriceLink = styled(Link)<PriceLinkProps>`
    margin-right: ${props => (props.saleprice ? "0" : "0.3rem")};
    display: inline-block;
`

export const SalePrice = styled(Typography, {
    shouldForwardProp: prop => !String(prop).startsWith("$"),
})<SalePriceProps>`
    margin: ${({$brandNameEnabled}) => ($brandNameEnabled ? "0rem" : "inherit")};
    color: ${({$brandedMarkdownSalePrice, theme}) =>
        $brandedMarkdownSalePrice
            ? theme.colours.brand.markdown.default.textColor
            : theme.colours.brand.sale.default.textColor};
    font-family: ${({theme}) => `${theme.colours.font.primary.medium.family}, ${theme.colours.font.default}`};
    font-weight: ${({theme}) => theme.colours.font.primary.medium.weight};
    ${({theme}) =>
        theme.enablingCenteredContent &&
        `
        justify-content: center;
    `}
    min-height: 1.4rem;
`

export const WasPrice = styled(Typography, {
    shouldForwardProp: prop => !String(prop).startsWith("$"),
})<PriceTextProps>`
    margin: ${({$brandNameEnabled}) => ($brandNameEnabled ? "0rem" : "inherit")};
    font-family: ${({theme}) => `${theme.colours.font.primary.medium.family}, ${theme.colours.font.default}`};
    font-weight: ${({theme}) => theme.colours.font.primary.medium.weight};
    display: inline-flex;
    ${({theme}) =>
        theme.enablingCenteredContent &&
        `
        justify-content: center;
    `}
    min-height: 1.281rem;
    align-items: baseline;

    &.prod-sum-price-line-through {
        text-decoration: line-through;
    }
`

export const PriceValue = styled(Typography)`
    font-family: ${({theme}) => `${theme.colours.font.primary.medium.family}, ${theme.colours.font.default}`};
    font-weight: ${({theme}) => theme.colours.font.primary.medium.weight};
    min-height: 1.4rem;
    display: flex;
`

export const DesktopWidth = styled("div")`
    @media (max-width: ${breakpoints.values.lg - 1}px) {
        display: none;
    }
`
export const MobileWidth = styled("div")`
    display: none;
    @media (max-width: ${breakpoints.values.lg - 1}px) {
        display: block;
    }
`

export const FromPrice = styled(Typography)`
    font-family: ${({theme}) => `${theme.colours.font.primary.medium.family}, ${theme.colours.font.default}`};
    font-weight: ${({theme}) => theme.colours.font.primary.medium.weight};
`

export const RectangleDivider = styled("div")`
    height: 1.4rem;
    width: 100%;
    &::after {
        position: relative;
        content: "";
        border-bottom: 0.125rem solid ${({theme}) => theme.colours.other.divider};
        width: 1rem;
        bottom: -0.7rem;
        display: block;
        margin: auto;
    }
`

export const Spacer = styled("span")`
    margin-inline-start: 0.5rem;
`

export const StarRatingWrapper = styled("div")`
    display: flex;
    min-height: 1.6rem;
`
